// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"loader_loaderOverlay__fvglZ","loaderSpinner":"loader_loaderSpinner__vGDLk"};